<template>
  <div class="TopMenuView top-menu" id="topmenu" ref="menu">
    <!--     <div class="topmenu_left">
      <a href="/"><TopMenuItem label="WebMonitor"/></a>
    </div>
 -->
    <!-- <div class="topmenu_center" v-if="ready_to_render"> -->
    <div
      class="topmenu_left"
      ref="left"
      v-if="ready_to_render"
      v-show="current_route.name != 'login'"
    >
      <TopMenuItem
        :hide_label="compact"
        :label="$txt.customers"
        :icon="$icon.customers"
        :route="{ name: 'customers' }"
        v-show="$appm.can_see_customer_tab"
        :tab_selected="$appm.maintab == 'customers'"
      />
      <TopMenuItem
        :hide_label="compact"
        :label="$txt.projects"
        :icon="$icon.projects"
        :route="{ name: 'project_manager' }"
        :tab_selected="$appm.maintab == 'projects'"
      />
      <!--       <TopMenuItem
        :label="$txt.users"
        :icon="$icon.user"
        :route="{ name: 'users' }"
        v-show="$app.session.current_user.can_see_users_tab"
        :tab_selected="$app.maintab == 'users'"
      />
 -->
      <TopMenuItem
        :hide_label="compact"
        :label="$txt.settings"
        :icon="$icon.app_settings"
        :route="{ name: 'settings' }"
        :tab_selected="$appm.maintab == 'settings'"
      />
    </div>

    <div class="topmenu_right" ref="right" v-show="this.$route.name != 'login'">
      <div class="top_menu_item top_menu_button" v-if="show_documentation">
        <TopMenuItem
          :hide_label="compact"
          :icon="$icon.documentation"
          :label="!documentation_open ? $txt.documentation : 'Close Documentation'"
          @click="$emit('toggle-documentation')"
        />
      </div>
      <div class="top_menu_item top_menu_button">
        <TopMenuItem
          :hide_label="compact"
          :icon="$icon.news"
          :label="!news_panel_open? $txt.news : $txt.close_news"
          @click="$emit('toggle-news')"
        />
      </div>
      <div class="top_menu_item top_menu_button">
        <TopMenuItem
          :hide_label="compact"
          :icon="$icon.user_manual"
          :label="!manuals_panel_open ? $txt.user_manual : $txt.close_user_manual"
          @click="$emit('toggle-manuals')"
        />
      </div>

      <AccountMenu />
    </div>
  </div>
</template>

<script>
import TopMenuItem from "@/components/topmenu/TopMenuItem";
import AccountMenu from "@/components/topmenu/AccountMenu";
import router from '@/router';
import globalSettings from "@/globalsettings.js";

export default {
  components: { TopMenuItem, AccountMenu },
  name: "TopMenuView",

  props: {
    show_documentation: Boolean
  },

  data() {
    return {
      globalSettings,
      compact: false
    };
  },

  mounted() {
    this.width_with_labels = 0;
    this.resize_observer = new ResizeObserver(() => this.schedule_fit_check());
    this.observe_sections();
    document.fonts?.ready.then(() => this.schedule_fit_check());
  },

  updated() {
    this.observe_sections();
  },

  beforeUnmount() {
    this.resize_observer.disconnect();
    cancelAnimationFrame(this.fit_check_frame);
  },

  methods: {
    observe_sections() {
      for (const el of [this.$refs.menu, this.$refs.left, this.$refs.right])
        if (el) this.resize_observer.observe(el);
    },

    schedule_fit_check() {
      cancelAnimationFrame(this.fit_check_frame);
      this.fit_check_frame = requestAnimationFrame(() => this.fit_check());
    },

    fit_check() {
      const menu = this.$refs.menu;
      if (!menu) return;
      const style = getComputedStyle(menu);
      const available = menu.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

      if (this.compact) {
        if (available >= this.width_with_labels) this.compact = false;
        return;
      }

      const left = this.$refs.left?.offsetWidth || 0;
      const right = this.$refs.right?.offsetWidth || 0;
      this.width_with_labels = left + right;
      if (this.width_with_labels > available) this.compact = true;
    }
  },
  computed: {
    ready_to_render() {
      return this.$appm.logged_in();
    },
    current_route() {
      return router.currentRoute.value;
    },
    news_panel_open() {
      return globalSettings.newsWindowOpen;
    },
    manuals_panel_open() {
      return globalSettings.manualsWindowOpen;
    },
    documentation_open() {
      return globalSettings.nodeDocsWindowOpen;
    }
  },
};
</script>
